module.exports = __webpack_public_path__ + "static/media/logo.9b43281f.png";